const TERMS = {
  TARGET_TYPE_OPTIONS: [
    {
      label: 'Cart',
      value: 'cart',
    },
    {
      label: 'Product',
      value: 'product',
    },
    {
      label: 'Product + Option',
      value: 'product_option',
    },
    {
      label: 'Product + Product',
      value: 'product_product',
    },
  ],
  VALUE_TYPE_OPTIONS: [
    {
      label: '$',
      value: 'fixed',
    },
    {
      label: '%',
      value: 'percentage',
    },
  ],
  USERS_TYPE_OPTIONS: [
    {
      label: 'Specific user(s)',
      value: 'specific',
    },
    {
      label: 'All users',
      value: 'any',
    },
  ],
  LIMIT_OPTIONS: [
    {
      label: 'Limited usage',
      value: 'limited',
    },
    {
      label: 'Unlimited',
      value: 'unlimited',
    },
  ],
};

export default TERMS;
